import { render, staticRenderFns } from "./browser.not.supported.vue?vue&type=template&id=b5e2e240&scoped=true"
import script from "./browser.not.supported.vue?vue&type=script&lang=js"
export * from "./browser.not.supported.vue?vue&type=script&lang=js"
import style0 from "./browser.not.supported.vue?vue&type=style&index=0&id=b5e2e240&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5e2e240",
  null
  
)

export default component.exports